import { FC, useState, useEffect } from 'react';
import { Button, Confirm, Icon, Modal, Dimmer, Loader, ModalProps } from 'semantic-ui-react';
import Table from './Table';
import {TextCell, ButtonCell} from './Table';
import { Container } from 'semantic-ui-react';
import IOApiTable, { IOApiTableActions } from './IOApiTable';
import { api, useApi } from '../api/api';
import { SqlFiltersEvent } from '../api/sql_filters'
import { envColor } from '../common'

interface Props extends ModalProps {
    onClose: () => void;
}


const SqlFiltersWindow: FC<Props> = (props) => {
    const sqlApi = useApi(api.sqlFilters);

    const [actions, setActions] = useState<IOApiTableActions>();
    const { onRestore, onClose, onApply, onForm } = props;
    const [loading, setLoading] = useState(true);
    const [events, setEvents] = useState<SqlFiltersEvent[]>([]);



    useEffect(() => { onLoad() }, []);

    const load = async () => {
        setLoading(true);

        return sqlApi
            .index(
            )
            .catch(e => console.error(e))
            .finally(()=>setLoading(false));
    }

    const onLoad = async () => {

        const content: SqlFiltersEvent[] = await load()
        setEvents(content)
        return content
    }

    const onDelete = async (id: string) => {

        return sqlApi
            .delete(
                id
            )
            .then(() => {})
            .catch(e => console.error(e))
            .finally(()=>onLoad());
    }


    return (
        <Modal
            size='large'
            style={{ minWidth: '70%', maxWidth: '95%' }}
            closeIcon
            open={true}
            onClose={onClose}
        >

            <Modal.Header>Filters</Modal.Header>
            <Modal.Content scrolling>
            {loading ?
            <Dimmer inverted active={true}><Loader/></Dimmer> :
            <>      
            <Table rows={events ?? []}  definition>
                <ButtonCell
                    header=''
                    icon='delete'
                    value={x=>x.id}
                    onClick={onDelete}
                    color={envColor}
                />
                <ButtonCell
                    header=''
                    icon='copy'
                    onClick={onRestore}
                    value={x=>x.sql_query}
                    color={envColor}
                />
                <TextCell header='Id' value={x => x.id} />
                <TextCell header='Author' value={x => x.author} />
                <TextCell header='Query' value={x => x.sql_query} />
                <TextCell header='Tag' value={x => x.tag} />
            </Table>
            </>
        }
            </Modal.Content>

            <Modal.Actions>
                <Button circular onClick={onForm}>
                    Add
                </Button>

                <Button circular onClick={onClose}>
                    Close
                </Button>
            </Modal.Actions>
        </Modal>
  )
}

export default SqlFiltersWindow;